import type { FC } from "react"

import type { InventoryByProductWarehouse } from "@/graphql/codegen/graphql"
import { formatNumber } from "@/utils/number"

interface ProductInventoryQtyOnHandStackProps {
  inventories: InventoryByProductWarehouse[]
  qtyOnHand: number
}

export const ProductInventoryQtyOnHandStack: FC<ProductInventoryQtyOnHandStackProps> = ({ inventories, qtyOnHand }) => {
  if (!inventories.length) return null

  return (
    <div className='flex flex-col gap-y-1'>
      {inventories.length > 1 && <div>{formatNumber(qtyOnHand)}</div>}
      {inventories.map((inventory) => (
        <div key={inventory.warehouseId}>{formatNumber(inventory.qtyOnHand)}</div>
      ))}
    </div>
  )
}
